import { render, staticRenderFns } from "./MatrixCell.vue?vue&type=template&id=1dbc10de"
import script from "./MatrixCell.vue?vue&type=script&lang=ts"
export * from "./MatrixCell.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports